import React from "react";
import { Helmet } from "react-helmet";
import MegaHeader from "../components/MegaHeader/MegaHeader";
import Footer from "../components/footer/Footer";
import SoftwareCompanyCta from "../components/software-company-cta/SoftwareCompanyCta";
import ServicesPageBanner from "../components/services-page-banner/ServicesPageBanner";
import TrustedPartner from "../components/trustedPartners/TrustedPartner";
import OurServices from "../components/our-services/OurServices";
import { AiMlPageData } from "../data/ai-ml-data";
import FAQ from "../components/Fqas/FAQ";
import TrendsInsights from "../components/trends-n-insights/TrendsInsights";
import SimpleModels from "../components/simpleEngagementModels";
import PioneeringChange from "../components/pioneeringChange/PioneeringChange";
import tabData from "../data/industryData";
import NewTestimonials from "../components/new-testimonials/NewTestimonials";
import { useTranslation } from "react-i18next";
import WhyChooseUs from "../components/why-choose-us/WhyChooseUs";
import NewCaseStudySection from "../components/new-case-study-section/NewCaseStudySection";
import CoverTheStack from "../components/coverthestack/CoverTheStack";
import NewRoadMap from "../components/new-raodmap-section/NewRoadMap";
import MegaMenu from "../components/MegaMenu/MegaMenu";

const AiMlServices = () => {
  const { t } = useTranslation("engagementModelContent");

  // grab the full object once
  // const engagementModelsContent = {
  //   heading: t("heading"),
  //   darkHeading: t("darkHeading"),
  //   subheading: t("subheading"),
  //   models: t("models", { returnObjects: true }),
  //   cta: t("cta", { returnObjects: true }),
  // };

  const { t: stackData } = useTranslation("aiDevelopmentPageContent");
  const coverTheStackData = stackData("aiDevCoverTheStackSection", {
    returnObjects: true,
  });

  return (
    <>
      <Helmet>
        <title>AI Powered, ML Consulting & Development Company| Bitsclan</title>
        <meta
          name="description"
          content="Power your business with our AI ML consulting & development services. Our AI experts deliver custom AI/ML solutions, agentic AI, chatbots, and more for growth."
        />
      </Helmet>

      <MegaMenu />

      <ServicesPageBanner
        shortHeading={AiMlPageData?.bannerContent?.shortHeading}
        mainHeading={AiMlPageData?.bannerContent?.mainHeading}
        description={AiMlPageData?.bannerContent?.description}
      />

      <TrustedPartner />

      <OurServices
        buttonText="Start Your AI Journey"
        servicesCardsData={AiMlPageData?.aimlServices?.cardsData}
        shortHeading={AiMlPageData?.aimlServices?.shortHeading}
        mainHeading={AiMlPageData?.aimlServices?.heading}
        description={AiMlPageData?.aimlServices?.description}
      />

      <NewTestimonials
        shortHeading={AiMlPageData?.testimonialData?.shortHeading}
        mainHeading={AiMlPageData?.testimonialData?.mainHeading}
        description={AiMlPageData?.testimonialData?.description}
        content={AiMlPageData?.testimonialData?.testimonials}
      />

      <WhyChooseUs
        heading={AiMlPageData?.whyUsContent?.heading}
        greenHeading={AiMlPageData?.whyUsContent?.greenHeading}
        shortHeading={AiMlPageData?.whyUsContent?.shortHeading}
        content={AiMlPageData?.whyUsContent?.content}
        stats={AiMlPageData?.whyUsContent?.stats}
        cta={AiMlPageData?.whyUsContent?.cta}
        sectionImage={AiMlPageData?.whyUsContent?.image}
      />

      <NewCaseStudySection
        shortHeading={AiMlPageData?.caseStudyContent?.shortHeading}
        heading={AiMlPageData?.caseStudyContent?.heading}
        description={AiMlPageData?.caseStudyContent?.description}
      />

      <CoverTheStack
        whereStart={"Generative AI Models"}
        shortHeading={"AI & ML Tech Stack"}
        mainHeading={"Enterprise-Grade Technology Stack for AI & ML Development"}
        subHeading={
          "Bitsclan deploys next generation AI & ML technologies, frameworks, & platforms to construct scalable, future-proof solutions. Our team partners with organizations to speed technologies, leverage intelligent automation to elevate workflow, & drive measurable growth."
        }
        tabs={coverTheStackData?.tabs}
        tabItems={coverTheStackData?.tabItems}
      />

      {/* <SimpleModels /> */}

      <SimpleModels content={AiMlPageData?.engagementModels} />

      <PioneeringChange
        tabData={AiMlPageData.industries.tabData}
        serviceTags={AiMlPageData.industries.serviceTags}
        // showIndustries={["Healthcare", "Fintech", "E-commerce & Retail", "Real Estate", "Automotive", "Education"]}
        shortHeading="Industries We Serve"
        greenHeading={"Through AI & ML Leadership"}
        mainHeading={"Redefining Industries "}
        content={
          "Driving innovation & transforming industries with advanced AI & ML expertise & actionable insights."
        }
      />

      <NewRoadMap roadmapContent={AiMlPageData?.roadmapContent} />

      <TrendsInsights
        category="ai-developmet"
        heading={AiMlPageData?.trendingInsights.heading}
        description={AiMlPageData?.trendingInsights.description}
      />

      <FAQ
        faqs={AiMlPageData.faqSection.questionAnswers}
        mainHeading={AiMlPageData.faqSection.heading}
      />
      <SoftwareCompanyCta content={AiMlPageData?.companyCta} />
      <Footer />
    </>
  );
};

export default AiMlServices;
